import { useState } from "react";
import { LoaderContext } from "./contexts/LoaderContext"
import { ILoaderProviderProps } from "../types/ILoaderProviderProps"

const LoaderProvider = (props: ILoaderProviderProps) => {
    const [isLoading, setIsLoading] = useState<boolean | null>(false);

    return (
        <LoaderContext.Provider value={{isLoading, setIsLoading}}>
            { props.children }
        </LoaderContext.Provider>
    )   
}

export default LoaderProvider;